module.exports = __webpack_public_path__ + "img/list-icon6.f143b40a.png";